<template>
    <div style="background:#f2f2f2;padding-bottom: 30px;" v-loading="loading">
        <!--banner-->
        <div class="nbanner"> 
            <a :href="item.adv_url?item.adv_url.url:'javascript:void(0)'" :target="item.adv_url?'_blank':''" v-for="item in bannerlist" :key="item.adv_id">
               <img :src="$util.img(item.adv_image)" alt="">
            </a>
            <!-- <img v-if="bannerlist.length<=0" src="@/assets/styles/images/ny7.png" alt=""> -->
        </div>
        <!--主体开始-->
        <section class="section container01">
            <div class="tj1">
                <div class="title">
                    <div class="z">
                        <h2>热门 <span>专家</span></h2>
                    </div>
                    <a href="/agricultural/expertlist"><img src="@/assets/styles/images/more1.png" alt=""> </a>
                </div>
                <ul class="zhuanjia">
                    <li v-for="item in hotexpertList" :key='item.id'>
                        <div class="sh">
                            <div class="z"><img :src="$util.img(item.image)" alt=""></div>
                            <div class="y">
                                <h2>{{item.name}}·{{item.title}} | <a :href="'/agricultural/expertdetails?id='+item.id">详情</a></h2>
                                <p>{{item.unit}}</p>
                            </div>
                        </div>
                        <div class="zh">
                            <h2>{{item.askCount}} <span>咨询量</span></h2>
                            <h2>{{item.answer_rate}}<span>回复率</span></h2>
                        </div>
                        <div class="xia">擅长：{{item.expert_in}}</div>
                        <a :href="'/agricultural/expertdetails?id='+item.id" class="btn">免费提问</a>
                    </li>
                </ul>
            </div>
            <div class="tj2">
                <div class="title">
                    <div class="z">
                        <h2>最新 <span>问答</span></h2>
                    </div>
                    <a href="/agricultural/questionlist"><img src="@/assets/styles/images/more1.png" alt=""></a>
                </div>
                <ul class="wenda">
                    <li v-for="item in newquestionList" :key='item.id'>
                        <a :href="'/agricultural/questiondetails?id='+item.id">
                            <div class="wen">
                                <span>问</span>
                                <p>{{item.content}}</p>
                            </div>
                            <div class="da">
                                <span>答</span>
                                <p>{{item.answer_content}}</p>
                            </div>
                            <div class="xia">
                                <p>全部{{item.answer_count}}条信息</p>
                                <p>更新于{{ $util.timeStampTurnTime(item.answer_time, 'YYYY-MM-DD') }}</p>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
            <div class="tj3">
                <div class="title">
                    <div class="z">
                        <h2>推荐 <span>文章</span></h2>
                        <!-- <p>最新更新时间12-21</p> -->
                    </div>
                    <a href="/information/list?tid=33"><img src="@/assets/styles/images/more1.png" alt=""> </a>
                </div>
                <ul class="wenzhang">
                    <li v-for="item in recommentList" :key="item.id">
                        <a :href="'/information/details?id='+item.id">
                            <div class="tu"> <img :src="$util.img(item.image)" alt=""> </div>
                            <div class="y">
                                <h4>{{item.title}}</h4>
                                <p> <span>{{item.author}}</span> <span>{{ $util.timeStampTurnTime(item.createtime, 'YYYY-MM-DD') }}</span> </p>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </section>
        <section class="section container06">
            <div class="tj1">
                <div class="title">
                    <div class="z">
                        <h2>农技 <span>专家</span></h2>
                    </div>
                    <a href="/agricultural/expertlist"><img src="@/assets/styles/images/more1.png" alt=""> </a>
                </div>
                <ul class="zhuanjia">
                    <li v-for="item in expertList" :key="item.id">
                        <div class="sh">
                            <div class="z"><img :src="$util.img(item.image)" alt=""></div>
                            <div class="y">
                                <h2>{{item.name}}·{{item.title}} | <a :href="'/agricultural/expertdetails?id='+item.id">详情</a></h2>
                                <p>{{item.unit}}</p>
                            </div>
                        </div>
                        <div class="zh">
                            <h2>{{item.askCount}} <span>咨询量</span></h2>
                            <h2>{{item.answer_rate}}<span>回复率</span></h2>
                        </div>
                        <div class="xia">擅长：{{item.expert_in}}</div>
                        <a :href="'/agricultural/expertdetails?id='+item.id" class="btn">免费提问</a>
                    </li>
                </ul>
            </div>
        </section>
        <section class="section container06">
            <div class="tj1" style="height: 380px">
                <div class="title">
                    <div class="z">
                        <h2>专家 <span>问答</span></h2>
                    </div>
                    <a href="/agricultural/questionlist"><img src="@/assets/styles/images/more1.png" alt=""> </a>
                </div>
                <ul class="wenda">
                     <li v-for="item in questionList" :key='item.id'>
                        <a :href="'/agricultural/questiondetails?id='+item.id">
                            <div class="wen">
                                <span>问</span>
                                <p>{{item.content}}</p>
                            </div>
                            <div class="da">
                                <span>答</span>
                                <p>{{item.answer_content}}</p>
                            </div>
                            <div class="xia">
                                <p>全部{{item.answer_count}}条信息</p>
                                <p>更新于{{ $util.timeStampTurnTime(item.answer_time, 'YYYY-MM-DD') }}</p>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </section>

        <section class="section container05">
            <div class="m">
                <div class="news-qh">
                    <div class="news-A1" style="width: 30%">
                        <div class="sh"> <strong class="title-news">农技 <span>文章</span></strong> <a href="/information/list?tid=33">更多<img src="@/assets/styles/images/more1.png" alt=""></a> </div>
                        <div class="xia">
                            <div class="news-slide">
                                <div class="flexslider">
                                    <ul class="slides">
                                        <li><a :href="'/information/details?id='+njImg.id"><img :src="$util.img(njImg.image)" alt="" /><span class="">{{njImg.title}}</span></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <ul class="mdInfo-A2">
                            <li class="text-overflow" v-for="item in njList" :key="item.id">
                                <a :href="'/information/details?id='+item.id" title="">
                                    <p style="overflow:hidden;text-overflow:ellipsis;white-space: nowrap;display:block">{{item.title}}</p>
                                    <span>{{ $util.timeStampTurnTime(item.createtime, 'YYYY-MM-DD') }}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="videoBox clearfix">
                        <div class="sh"> <strong class="title-news">农技 <span>课程</span></strong> <a href="/agricultural/courselist">更多<img src="@/assets/styles/images/more1.png" alt=""></a> </div>
                        <ul class="content_new">
                            <a :href="'/agricultural/coursedetails?id='+item.id" t="0" v-for="item in courseList" :key="item.id">
                                <li class="video_item">
                                    <div class="c_img">
                                        <img :src="$util.img(item.image)" class="lazy" data-original="" alt=" " />
                                        <div class="overlay"> <i class="iconfont icon-shipin"></i> </div>
                                    </div>
                                    <div class="c_info">
                                        <h6> <span class="caption">{{item.name}}</span> </h6>
                                        <p>{{ $util.timeStampTurnTime(item.createtime, 'YYYY-MM-DD') }}</p>
                                    </div>
                                </li>
                            </a>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import { informationList } from '@/api/information/information';
    import { expertList } from '@/api/expert/expert';
    import { questionList } from '@/api/expert/question';
    import { courseList } from '@/api/course/course';
    import { adList } from "@/api/website";

    export default {
        name: '',
        components: {},
        data: () => {
            return {
                loading: true,
                hotexpertList:[],
                newquestionList:[],
                recommentList:[],
                expertList:[],
                questionList:[],
                njList:[],
                njImg:{},
                courseList:[],
                bannerlist:[],
            };
        },
        created() {
            let wintitle = `${window.document.title}`;
            let title = wintitle.split('-')
            window.document.title = '农技服务 - ' + title[1];
            this.gethotexpertList();
            this.getnewquestionList();
            this.getrecommentList();
            this.getexpertList();
            this.getnjList();
            this.getcourseList();
            this.getbannerlist();
        },

        methods: {
            getbannerlist() {
                adList({
                    keyword:"PC_NONGJI_BANNER"
                }).then(res => {
                    if(res.code == 0) {
                        this.bannerlist = res.data.adv_list.slice(0,1);
                        for (let i = 0; i < this.bannerlist.length; i++) {
                            if (this.bannerlist[i].adv_url) this.bannerlist[i].adv_url = JSON.parse(this.bannerlist[i].adv_url)
                        }
                    }
                })
            },
          gethotexpertList() {
            expertList({
              order: "collection desc",
              limit: 2
            }).then(res => {
              if(res.code == 0) {
                this.hotexpertList = res.data;
                this.loading = false;
              }
            }).catch(err => {
                this.loading = false;
                //this.$message.error(err.message);
            });
          },
          getnewquestionList() {
            questionList({
              limit: 9
            }).then(res => {
              if(res.code == 0) {
                var list = res.data
                this.newquestionList = list.slice(0, 3);
                this.questionList = list.slice(3, 9);
              }
            });
          },
          getrecommentList() {
            informationList({
                typenumber: "10003",
                recommend: 'true',
                isImg: true,
                limit: 4
            }).then(res => {
              if(res.code == 0) {
                this.recommentList = res.data;
              }
            });
          },
          getexpertList() {
            expertList({
              limit: 3
            }).then(res => {
              if(res.code == 0) {
                this.expertList = res.data;
              }
            });
          },
          getnjList() {
            informationList({
              typenumber: "10003",
              recomment: false,
              limit: 10
            }).then(res => {
              if(res.code == 0) {
                var imglist = res.data.filter(function(item) {
                  return item.image != "";
                });
                if(imglist.length>0) {
                    this.njImg = imglist[0];
                    this.njList = res.data.filter(function(item) {
                        return item.id != imglist[0].id;
                    });
                }
              }
            });
          },
          getcourseList() {
            courseList({
              limit:8
            }).then(res => {
              if(res.code == 0) {
                this.courseList = res.data;
              }
            });
          },
        }

    }
</script>
